import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.10583 5.10583C1.29806 8.9136 1.29806 15.0866 5.10583 18.8944C8.9136 22.7022 15.0866 22.7022 18.8944 18.8944C22.7022 15.0866 22.7022 8.9136 18.8944 5.10583C15.0866 1.29806 8.9136 1.29806 5.10583 5.10583ZM14.6518 15.4013C14.8505 15.4012 15.0411 15.3222 15.1816 15.1816C15.3222 15.0411 15.4012 14.8505 15.4013 14.6518V10.4091C15.4049 10.3085 15.3881 10.2081 15.352 10.1141C15.316 10.0201 15.2613 9.93424 15.1914 9.86178C15.1214 9.78931 15.0376 9.73168 14.9449 9.69232C14.8522 9.65296 14.7525 9.63267 14.6518 9.63267C14.5511 9.63267 14.4514 9.65296 14.3587 9.69232C14.2659 9.73168 14.1821 9.78931 14.1122 9.86178C14.0422 9.93424 13.9876 10.0201 13.9515 10.1141C13.9154 10.2081 13.8987 10.3085 13.9022 10.4091L13.9022 12.8416L9.8788 8.81814C9.73815 8.67748 9.54738 8.59847 9.34847 8.59847C9.14955 8.59847 8.95879 8.67748 8.81814 8.81814C8.67749 8.95879 8.59847 9.14955 8.59847 9.34847C8.59847 9.54738 8.67749 9.73815 8.81814 9.8788L12.8416 13.9022L10.4091 13.9022C10.2149 13.9091 10.0309 13.9911 9.89598 14.1309C9.76101 14.2707 9.68559 14.4574 9.68559 14.6518C9.68559 14.8461 9.76101 15.0328 9.89598 15.1727C10.0309 15.3125 10.2149 15.3944 10.4091 15.4013L14.6518 15.4013Z"
        fill={colorValue}
      />
    </svg>
  );
};
